import { useEffect, useRef } from "react";
import "./contentBlock.css";

const ContentBlock = ({ title, text, style }) => {
  const blockRef = useRef(null);

  useEffect(() => {
    const currentBlockRef = blockRef.current; // Store the current value in a variable

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentBlockRef) {
      observer.observe(currentBlockRef);
    }

    return () => {
      if (currentBlockRef) {
        observer.unobserve(currentBlockRef); // Use the stored variable in the cleanup function
      }
    };
  }, []); // Empty dependency array ensures this runs only once

  return (
    <div ref={blockRef} className="reveal" style={style}>
      <h3 className="textBold">{title}</h3>
      <p className="text">{text}</p>
    </div>
  );
};

export default ContentBlock;
